module.exports = __webpack_public_path__ + "img/cp-7.2ead75df.jpg";